import { findEvent } from '../../../packages/src/api/index.js';
import localization from '../localization/page.js';
import { occoApi } from './occoAPI-module.js';

const MAX_NUMBER_OF_PHOTOS = 3000;

export const pageParams = {
  resetData: () => localStorage.clear(),
  eventName: () => localStorage.getItem('eventName'),
  saveEventName: (eventName) => localStorage.setItem('eventName', eventName),
  homeLink: () => localStorage.getItem('locWA'),
  saveHomeLink: (homeLink) => localStorage.setItem('locWA', homeLink),
  attendeeUid: () => localStorage.getItem('attUidWA'),
  saveAttendeeUid: (attendeeUid) => localStorage.setItem('attUidWA', attendeeUid),
  generatedAttId: () => localStorage.getItem('generatedAttId'),
  saveGeneratedAttId: (generatedAttId) => localStorage.setItem('generatedAttId', generatedAttId),
  regDate: () => localStorage.getItem('regDate'),
  saveRegDate: (regDate = new Date()) => localStorage.setItem('regDate', regDate),
};

/**
 * @typedef {Object} ValidationVariant
 */

/**
 * Make a validation variant
 *
 * @param isValid {Function}
 * @param message {String}
 * @returns {ValidationVariant}
 */
function makeValidationVariant(isValid, message) {
  return {
    isValid,
    message,
  };
}

export const validationVariants = {
  isAssignedAttendeeUid: makeValidationVariant(
    () => pageParams.attendeeUid() !== null,
    'AttendeeUid is not assigned in local storage'
  ),
  isSetUpEventName: makeValidationVariant(
    () => Boolean(pageParams.eventName()),
    'Invalid event code. Please contact support'
  ),
};

export function assertPageParams(validationList) {
  const error = getError();
  if (error) {
    // NOTE: Show error until fixed
    alert(error.message);
    window.location.reload();
  }

  function getError() {
    return validationList.find((validation) => !validation.isValid());
  }
}

export const fetchData = {
  event: async (eventName = pageParams.eventName()) => {
    const { result } = await findEvent({ eventName });
    if (!result) {
      alert(localization.eventNotExist(eventName));
      window.location.reload();
    }
    return result;
  },
  photos: async (eventId, attUid = pageParams.attendeeUid()) =>
    new Promise((resolve, reject) => {
      occoApi.photoListRetrieve(
        'attendee_uid',
        attUid,
        eventId,
        null,
        null,
        null,
        MAX_NUMBER_OF_PHOTOS,
        null,
        null,
        null,
        false,
        null,
        null,
        null,
        null,
        null,
        attUid,
        true,
        null,
        null,
        (err, result) => {
          if (err) {
            reject(err);
          } else {
            resolve(result);
          }
        }
      );
    }),
};
